import { indigo as A, red as w, green as N, yellow as E, brown as T, deepOrange as x, blueGrey as D, teal as C, pink as F, purple as I } from "@mui/material/colors";
import m from "react";
function L(e) {
  let t = 0, r;
  for (r = 0; r < e.length; r += 1)
    t = e.charCodeAt(r) + ((t << 5) - t);
  let u = "#";
  for (r = 0; r < 3; r += 1) {
    const l = t >> r * 8 & 255;
    u += `00${l.toString(16)}`.slice(-2);
  }
  return u;
}
function O(e) {
  const t = L(e), r = e.split(" ");
  return {
    bgcolor: t,
    initials: `${r[0][0] ? r[0][0] : ""}${r.length > 1 ? r[1][0] : ""}`
  };
}
const U = (e) => Intl.NumberFormat("en-AU", { style: "currency", currency: "AUD" }).format(e);
function $(e, t) {
  if (t && (t.allowLinks || t.allowIframes))
    return M(e, t);
  const r = e.replace(/<[^>]*>/g, "");
  return y(r);
}
function y(e) {
  const t = {
    "&amp;": "&",
    "&lt;": "<",
    "&gt;": ">",
    "&quot;": '"',
    "&#39;": "'",
    "&#x2F;": "/",
    "&#x60;": "`",
    "&#x3D;": "=",
    "&nbsp;": " "
  };
  return e.replace(/&[a-zA-Z0-9#]+;/g, (r) => t[r] || r);
}
function M(e, t) {
  const u = new DOMParser().parseFromString(e, "text/html"), l = (o, a) => {
    if (o.nodeType === Node.TEXT_NODE)
      return y(o.textContent || "");
    if (o.nodeType === Node.ELEMENT_NODE) {
      const n = o, h = n.tagName.toLowerCase();
      if (h === "a" && t.allowLinks) {
        const c = n.getAttribute("href") || "", i = n.getAttribute("target") || "_blank", g = n.getAttribute("rel") || "noopener noreferrer", f = Array.from(n.childNodes).map((s, b) => l(s, b));
        return m.createElement("a", {
          key: a,
          href: c,
          target: i,
          rel: g,
          style: {
            color: "var(--mui-palette-primary-main, inherit)",
            textDecoration: "none"
          },
          onMouseEnter: (s) => {
            s.currentTarget.style.textDecoration = "underline";
          },
          onMouseLeave: (s) => {
            s.currentTarget.style.textDecoration = "none";
          }
        }, ...f);
      }
      if (h === "iframe" && t.allowIframes) {
        const c = n.getAttribute("src") || "", i = n.getAttribute("width") || "100%", g = n.getAttribute("height") || "400", f = n.getAttribute("title") || "Embedded content";
        return m.createElement("iframe", {
          key: a,
          src: c,
          width: i,
          height: g,
          title: f,
          frameBorder: "0",
          allowFullScreen: !0,
          sandbox: "allow-scripts allow-same-origin allow-presentation",
          loading: "lazy",
          referrerPolicy: "no-referrer",
          style: { maxWidth: "100%" }
        });
      }
      const p = Array.from(n.childNodes);
      if (p.length > 0)
        return p.map((c, i) => l(c, a * 1e3 + i));
    }
    return null;
  }, d = Array.from(u.body.childNodes).map((o, a) => l(o, a)).filter((o) => o !== null);
  return d.length === 0 ? null : d.length === 1 ? d[0] : m.createElement(m.Fragment, {}, ...d);
}
function H(e) {
  const t = [
    A[500],
    w[900],
    N[500],
    E[500],
    T[500],
    x[500],
    D[500],
    C[500],
    F[500],
    I[500]
  ];
  return e < t.length ? t[e] : `hsl(${e * 137.508 % 360}, 65%, 60%)`;
}
function P(e) {
  try {
    return encodeURIComponent(e).replace(/%20/g, "+").replace(/%[0-9A-F]{2}/g, (t) => t.toLowerCase());
  } catch {
    return e;
  }
}
function S(e) {
  try {
    return decodeURIComponent(e.replace(/\+/g, " "));
  } catch {
    return e;
  }
}
export {
  U as formatMoney,
  H as getColorForIndex,
  O as stringAvatar,
  $ as stripHtmlAndDecode,
  S as urlDecode,
  P as urlEncode
};
//# sourceMappingURL=strings.js.map
